export class ANPublisher {
  id: string;
  name: string;
  state: string;
  billingDba: string;
  billingAddress1: string;
  billingCity: string;
  billingState: string;
  billingZip: string;
  contact: ANPublisherContact = new ANPublisherContact();
}

export class ANPublisherContact {
  name: string;
  email: string;
  phone: string;
}
